<div [ngClass]="['input-wrapper', 'input-' + size]" [class.input-error]="error">
    <ng-content select="[climbIcon]:not([iconPositionEnd]), [positionStart]"></ng-content>

    <ng-content select="[climbInput]"></ng-content>

    <ng-content select="[climbIcon][iconPositionEnd], [positionEnd]"></ng-content>
</div>

<ng-content select="[climbInputHint], [climbInputError]"></ng-content>
